interface V1ExpenseRequestErrorBody {
  detail?: { expense_report_error?: Record<string, string[]> }
  data?: { __all__?: string[] }
}

export const mapV1ExpenseRequestErrorMessage = (
  body: unknown
): string | undefined => {
  if (!body || typeof body !== 'object') return undefined

  const typed = body as V1ExpenseRequestErrorBody

  const fieldErrors = typed.detail?.expense_report_error
  if (fieldErrors) {
    const [firstField, firstFieldErrors] = Object.entries(fieldErrors)[0] ?? []
    if (firstField && firstFieldErrors?.[0]) {
      return `${firstField}: ${firstFieldErrors[0]}`
    }
  }

  return typed.data?.__all__?.[0]
}
